import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { Label } from 'src/jbc-front/components/Form';
import formStyles from 'jbc-front/components/Form.scss';
import { CustomYearPicker } from 'src/features/Employees/components/CustomYearPicker';

const YearPickerField = ({ input, label, required, placeholder, defaultToCurrentYear, maxYear }) => {
  const handleYearChange = selectedDate => {
    const selectedYear = moment(selectedDate).year();
    input.onChange(selectedYear);
    input.onBlur(selectedYear);
  };

  const isValidYear = date => {
    const selectedYear = moment(date).year();
    return selectedYear <= maxYear;
  };

  const currentYear = moment().year();
  const value = input.value || (defaultToCurrentYear ? currentYear : '');

  if (label) {
    return (
      <div className={formStyles.boxWrap}>
        <Label text={label} required={required} />
        <CustomYearPicker value={value} onChange={handleYearChange} placeholder={placeholder || currentYear.toString()} isValidDate={isValidYear} />
      </div>
    );
  }

  return <CustomYearPicker value={value} onChange={handleYearChange} placeholder={placeholder} isValidDate={isValidYear} />;
};

YearPickerField.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired
  }).isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  defaultToCurrentYear: PropTypes.bool,
  maxYear: PropTypes.number
};

YearPickerField.defaultProps = {
  label: '',
  required: false,
  placeholder: '',
  defaultToCurrentYear: false,
  maxYear: moment().year()
};

export default YearPickerField;
